export const serviceBrands = [
  'patientrewardshub',
  'hubbux',
  'culturello',
] as const;
export type ServiceBrand = typeof serviceBrands[number];

/**
 * Given a hostname from a URL, get the corresponding ServiceBrand.
 * Fallback to `patientrewardshub` for unknown hosts.
 */
export const resolveServiceBrandFromHostname = (
  hostname: string
): ServiceBrand => {
  const host = hostname.replace(/.*?\.(.*?)\..*/, '$1') as
    | 'patientrewardshub'
    | 'hubbux'
    | 'culturello';
  const hostToServiceBrand = {
    patientrewardshub: 'patientrewardshub',
    hubbux: 'hubbux',
    culturello: 'culturello',
  } as const;

  return hostToServiceBrand[host] || 'patientrewardshub';
};

/**
 * If window exists, resolves the ServiceBrand from the hostname given by window.location.hostname
 * Otherwise, falls back to `ServiceBrand.patientrewardshub`.
 */
export const inferServiceBrandFromWindow = () =>
  typeof window === 'undefined'
    ? 'patientrewardshub'
    : resolveServiceBrandFromHostname(window.location.hostname);
